export default {
    install (Vue, options) {
        Vue.prototype.objClone = function(obj) {
            return JSON.parse(JSON.stringify(obj));
        };
        Vue.prototype.objMerge = function(newObj, obj) {
            return deepClone(obj, newObj);
            function deepClone(obj, newObj) {
                newObj = newObj || {};
                for (var key in obj) {
                    if (typeof obj[key] === 'object') {
                        newObj[key] = (obj[key].constructor === Array) ? [] : {};
                        deepClone(obj[key], newObj[key]);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
                return newObj;
            }
        };
        Vue.prototype.deepMerge = function(newObj, obj) {
            return deepClone(obj, newObj);
            function deepClone(obj, newObj) {
                newObj = newObj || {};
                for (var key in obj) {
                    if (typeof obj[key] === 'object') {
                        newObj[key] = (obj[key].constructor === Array) ? [] : {};
                        deepClone(obj[key], newObj[key]);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
                return newObj;
            }
        };
        Vue.prototype.shallowMerge = function(obj1, obj2) {
            return Object.assign({}, obj1, obj2);
        };
        Vue.prototype.isCanEditPreset = function(obj) {
            let isCan = true;
            if (obj.preset === 1) {
                if (!this.$store.state.common.isAdmin) {
                    isCan = false;
                }
            }
            if (!isCan) {
                this.$message.info('系统数据不能修改或删除!');
            }
            return isCan;
        };
    }
};
